import { assert } from '@deqo/foundation';


export class ContentPayload {

    public static unknownType = 'application/octet-stream';

    public static create(type: string, data: any, metadata: Record<string, any> = {}) {
        return new ContentPayload(type, data, metadata);
    }

    public static derive(original: ContentPayload, type: string, data: any, extraMetadata: Record<string, any> = {}) {
        return new ContentPayload(type, data, { ...extraMetadata, ...original.metadata }, original);
    }

    public static underive(payload: ContentPayload, extraMetadata: Record<string, any> = {}) {
        assert(!!payload.original, 'ContentPayload: cannot underive from original payload');
        const { type, data, metadata } = payload.original;
        return new ContentPayload(type, data, { ...metadata, ...extraMetadata }, payload);
    }

    public readonly type: string;
    public readonly data: any;
    public readonly metadata: Record<string, any>;
    public readonly original?: ContentPayload;

    private constructor(type: string, data: any, metadata: Record<string, any> = {}, original?: ContentPayload) {
        this.type = type;
        this.data = data;
        this.metadata = metadata;
        this.original = original;
    }

    public async getDataAsText() {
        // Check is file or blob or string
        if (!(typeof (this.data) === 'string' || this.data instanceof File || this.data instanceof Blob)) {
            // input must be a File or Blob.
            return null;
        }
        return typeof (this.data) === 'string' ? this.data : await this.data.text();
    }
}
